import React from 'react';
import { styled } from 'linaria/react';
import { css, cx } from 'linaria';
import { Link } from 'react-router-dom';
import Spinner from './Spinner';
import t from '@jetshop/intl';
import { theme } from '../Theme';
import ButtonUI from '@jetshop/ui/Button';
import { isRelativeUrl } from '@jetshop/core/helpers/isRelativeUrl';

export const baseStyles = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.accent};
  border-color: ${theme.colors.accent};
  color: white;
  font-size: calc(12rem / 16);
  border-radius: 999px;
  padding: 0 ${theme.space.md};
  height: 42px;
  font-weight: 600;
  letter-spacing: 1.2px;

  span {
    margin-right: 12px;
  }
  svg {
    fill: white;
    height: 1em;
    width: 1em;
    margin-right: 1em;
  }
  ${theme.above.md} {
    max-width: 100%;
  }

  :disabled {
    border: 1px solid #dedede;
    opacity: 0.5;
  }
`;

const BaseButton = styled('button')``;

const TrendABase = styled('a')`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

const TrendLinkBase = styled(Link)`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 54px;
`;

const StyledButton = styled(ButtonUI)``;

const ButtonLink = styled(Link)`
  text-decoration: none;
`;

export function TrendLink({ to, className, ...props }) {
  return typeof to === 'string' && !isRelativeUrl(to) ? (
    <TrendABase href={to} className={cx(className, baseStyles)} {...props} />
  ) : (
    <TrendLinkBase to={to} className={cx(className, baseStyles)} {...props} />
  );
}

const StyledSpinner = styled(Spinner)`
  height: 25px;
  circle.path {
    stroke: white;
  }
`;

export const Button = ({
  className = '',
  secondary = false,
  outline = false,
  link = '',
  ...props
}) => {
  return link !== '' && isRelativeUrl(link) ? (
    <ButtonLink
      to={link}
      className={cx(
        baseStyles,
        secondary && secondaryStyle,
        outline && outlineStyle,
        className
      )}
      {...props}
    />
  ) : (
    <StyledButton
      anchor={link !== ''}
      href={link}
      className={cx(
        baseStyles,
        secondary && secondaryStyle,
        outline && outlineStyle,
        className
      )}
      {...props}
    />
  );
};

const ButtonWithLoading = ({
  loading,
  loadingText = t('Hold on a moment...'),
  secondary,
  className,
  ...props
}) =>
  loading ? (
    <BaseButton
      {...props}
      className={cx(secondary && secondaryStyle, baseStyles, className)}
    >
      <span>{loadingText}</span>
      <StyledSpinner />
    </BaseButton>
  ) : (
    <BaseButton
      {...props}
      className={cx(secondary && secondaryStyle, baseStyles, className)}
    />
  );

export default ButtonWithLoading;

export const secondaryStyle = css`
  background-color: white;
  /* border: 1px solid ${theme.colors.darkgrey}; */
  color: ${theme.colors.darkgrey};
  circle.path {
    stroke: black;
  }
`;

const outlineStyle = css`
  background-color: transparent;
  &.${secondaryStyle} {
    color: ${theme.colors.white};
  }
  &:not(.${secondaryStyle}) {
    color: ${theme.colors.accent};
  }
`;
